package views.coletor

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import ffButton0
import ffSpan
import kotlinx.browser.document
import kotlinx.dom.clear
import lbTitulo
import model.Padrao
import ffMsgAviso
import ffMsgWindow
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import utils.*
import utils.ff.Companion.giClick
import utils.ff.Companion.goEMPRESA
import utils.ff.Companion.goFUNCIONARIO
import utils.ff.Companion.gsBrowser
import utils.ff.Companion.gsDesenvolvedor
//import utils.ff.Companion.gsKey
import utils.ff.Companion.gsNavePage
import utils.ff.Companion.gsUsuarioTemp
import utils.ff.Companion.gsVersao
import utils.ff.Companion.println0
import views.componentes.gsInput
import views.componentes.text

class principalCOL {

    var _t = "principalCOL"

    fun show() {
        gsNavePage = "#principalCOL"

        gsBrowser = kotlinx.browser.window.navigator.appVersion
        val browser = kotlinx.browser.window.navigator.appVersion
        if (browser.contains("Chrome"))
            gsBrowser = "Chrome"
        else if (browser.contains("Safari"))
            gsBrowser = "Safari"
        else
            gsBrowser = "Firefox"
        if (browser.contains("Linux"))
            gsBrowser = "Linux $gsBrowser"
        else if (browser.contains("Windows"))
            gsBrowser = "Windows $gsBrowser"
        if (browser.contains("Mobile"))
            gsBrowser = "$gsBrowser mobile"


        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()

        renderComposable(rootElementId = "htmlDiv1") {
            body()
            //if (lemp5 != null && lemp5!!.count() > 0)
            //body1(lemp5!!)
        }
    }

    @Composable
    fun body() {
        println0("body do principalCOL")
        println0(goEMPRESA)
        println0(goFUNCIONARIO)

        giClick = -1

        val _tarefas = remember { mutableStateOf(gsInput(_t)) }
        val _vencendo = remember { mutableStateOf(gsInput(_t)) }
        val _agenda = remember { mutableStateOf(gsInput(_t)) }
        Padrao().getProdutoLoteCount { sObj ->
            println0(sObj)
            _tarefas.text("TAREFAS - ${sObj.ffPegaCampo("|divergencias")}")
            _vencendo.text("VENCE EM 30 DIAS - ${sObj.ffPegaCampo("|vencendo")} + ${sObj.ffPegaCampo("|vencido")} VENCIDOS")
            _agenda.text("AGENDAMENTO DO DIA - ${sObj.ffPegaCampo("|agendamento")}")
        }
//        Notas().queryAgendamentoCount(5) { sTeste ->
//            _agenda.text("AGENDAMENTO - $sTeste")
//        }

        Div(attrs = { classes("dlg-pad-top-5") }) {

            Div(attrs = { classes("form-group") }) {
                ffButton0("CONSULTA DE PRODUTOS", { clickCol001Consulta() }, 100)
            }

            if (!ff.goFUNCIONARIO.FUNC_NOME.lowercase().contains("visitante") && ff.goFUNCIONARIO.FUNC_NOME != "" && ff.goFUNCIONARIO.FUNC_NOME.lowercase() != "user") {
                Div(attrs = { classes("form-group") }) {
                    ffButton0("ENTRADA / SAÍDA DE MERCADORIAS", { clickCol002Conferencia() }, 100)
                }
            }

            if (!gsDesenvolvedor.equals("P")) {
                Div(attrs = { classes("form-group") }) {
                    ffButton0(" ", { ffMsgWindow("Não faz nada") }, 100)
                }
            }

            Div(attrs = { classes("form-group") }) {
                ffButton0("LOTE DE SEPARAÇÃO", { clickCol007Separacao() }, 100)
            }

            Div(attrs = { classes("form-group") }) {
                ffButton0("INVENTÁRIO", { clickCol006Inventario() }, 100)
            }

            Div(attrs = { classes("form-group") }) {
                ffButton0(_agenda.text(), { clickCol010Agendamento() }, 100)
            }

            Div(attrs = { classes("form-group") }) {
                ffButton0(_tarefas.text(), { clickCol008listaDivergencia() }, 100)
            }

            Div(attrs = { classes("form-group") }) {
                ffButton0(_vencendo.text(), { clickCol009listaDivergencia() }, 100)
            }

            Div({ classes("input-group-append") }) {
                ffSpan(goEMPRESA.EMP_NOME, _align = "left", _width = 50)
                ffSpan("vr.: $gsVersao $gsBrowser", _align = "right", _width = 50)
                /*
                Div(attrs = { classes("form-group"); style { fontSize(fontSmall); width(50.percent); textAlign("left") }; }) {
                    ffSpan(goEMPRESA.EMP_NOME, _align = "left", _width = 50)
                }
                Div(attrs = { classes("form-group"); style { fontSize(fontSmall); width(50.percent); textAlign("right") }; }) {
                    ffSpan("vr.: $gsVersao $gsBrowser")
                }

                 */
            }
            Br()

            if (ff.goFUNCIONARIO.FUNC_NOME.lowercase().contains("visitante") || ff.goFUNCIONARIO.FUNC_NOME == "" || ff.goFUNCIONARIO.FUNC_NOME.lowercase() == "user") {
                Div({ classes("input-group-append") }) {
                    ffSpan("Visitante: ${ff.goFUNCIONARIO.FUNC_NOME}", _align = "left", _width = 50)
                }
                Div({ classes("input-group-append") }) {
                    ffSpan(
                        "Este APP funciona conectado a um ERP, seu objetivo e controlar o estoque de Produtos e Insumos, \n" +
                                "controlando lotes e validades do produto, coletando a informação via leitor código de barras \n" +
                                "ou informando o código do produto manualmente, como exemplo produto 23, os dados aqui contidos,\n" +
                                "são meramente ilustrativos defasados e inuteis , \n" +
                                "mas para seu funcionamento é necessário treinamento e o ERP,\n" +
                                "mais informações em www.dlogica.com.br.", _align = "left", _width = 100
                    )
                }
            }

        }
    }

    //******************************************************************************** INICIO DOS EVENTOS

    private fun clickCol001Consulta() {
        ffNavePage("col001")
    }

    private fun clickCol002Conferencia() {
        if (goFUNCIONARIO.FUNC_LOGON.lowercase().contains("visitante") || goFUNCIONARIO.FUNC_LOGON.lowercase().equals("user")) {
            ffMsgWindow("Acesso não permitido")
        } else {
            ffNavePage("col002")
        }
    }

    private fun clickCol006Inventario() {
        ffNavePage("col006")
    }

    private fun clickCol007Separacao() {
        ffNavePage("col007")
    }

    private fun clickCol008listaDivergencia() {
        ffNavePage("col008")
    }

    private fun clickCol009listaDivergencia() {
        ffNavePage("col009")
    }

    private fun clickCol010Agendamento() {
        ffNavePage("col010")
    }

    //quando vazio vai fazer o retorno
    fun ffNavePage(_destino: String, _param1: String = "") {

        //println0("principalCOL - ffNavePage")
        //gsKey = ""
        ffMsgAviso("")
        var sDest = _destino
        //descobre o a ultima tela aberta
        if (sDest.equals("")) {
            //println0("retorna um nível")

            sDest = gsNavePage.ffInverte()
            sDest = sDest.ffCopy(0, sDest.indexOf("#") + 1)
            sDest = sDest.ffInverte()
            //remove string
            gsNavePage = gsNavePage.replace(sDest, "")
            sDest = sDest.replace("#", "")
            //pega o que sobrou
            sDest = gsNavePage.ffInverte()
            sDest = sDest.ffCopy(0, sDest.indexOf("#") + 1)
            sDest = sDest.ffInverte()
            sDest = sDest.replace("#", "")
            // println0("retorna um nível " + sDest)
        } else {
            gsNavePage = "${gsNavePage}#$sDest"
            //println0("somado $gsNavePage")
        }

        lbTitulo!!.innerText = ""

        println0(sDest)
        if (sDest.equals("col001"))
            col001().show(_param1)
        else if (sDest.equals("col002"))
            col002().show(_param1)
        else if (sDest.equals("col003"))
            col003().show(_param1)
        else if (sDest.equals("col006"))
            col006().show()
        else if (sDest.equals("col007"))
            col007().show()
        else if (sDest.equals("col008"))
            col008().show()
        else if (sDest.equals("col009"))
            col009().show()
        else if (sDest.equals("col010"))
            col010().show()
        else if (sDest.equals("col007"))
            col007().show()
        else if ((sDest.equals("principalCOL")) || sDest.equals(""))
            principalCOL().show()
    }


}